$(function() {
  // https://github.com/burocratik/outdated-browser
  // Edge 16+ Supports [lowerThan: 'object-fit']  > IE11 not
  // For < IE11 use: [lowerThan: 'object-fit']
  outdatedBrowser({
    bgColor: '#f25648',
    color: '#ffffff',
    lowerThan: 'borderImage',
    languagePath: '/default/de.html'
  });


  // Open all Markdown-Links from external URL in new Tab
  $(document.links)
    .filter(function() {
      return this.hostname != window.location.hostname;
    })
    .attr('target', '_blank');

  // Object-Fit Polyfill
  objectFitImages();

  var effect = 'slide';
  var options = { direction: 'right' };
  var duration = 200;

  if (feature.touch) {
    $('.contact--slideout--reveal').on('click', function(e) {
      e.preventDefault();
      $('.contact--content').toggle();
    });
  } else {
    $('.contact--slideout--reveal').mouseenter(function(e) {
      $('.contact--content').toggle(effect, options, duration);
    });
    $('.contact--content').mouseleave(function(e) {
      $(this).toggle(effect, options, duration);
    });
  }

  $('.grid--reveal').on('click', function(e) {
    e.preventDefault();
    $(this)
      .parent()
      .prev()
      .slideToggle({ direction: 'left' });
    $(this).text(function(i, text) {
      // data-Attribute dependent Text-Switcher...
      return text == $(this).data('show')
        ? $(this).data('hide')
        : $(this).data('show');
    });
  });
  var $ct = $('.plus');
  $ct.on('click', function() {
    $(this)
      .next('ul')
      .slideToggle(250);
  });

  var $ct = $('.contact--slideout');
  $(window).bind('scroll', function() {
    clearTimeout($.data(this, 'scrollTimer'));
    $.data(
      this,
      'scrollTimer',
      setTimeout(function() {
        var top = $(window).scrollTop();
        if (top > 100) {
          $ct.addClass('scrolled');
        } else {
          $ct.removeClass('scrolled');
        }
      }, 250)
    );
  });
});
